import { BASE_QUERY, DEFAULT_SECTION_TOP_COUNT, ruleNewsPlus } from './shared/configs';

enum SECTION_ENUM {
  ECONOMY = 'Economy',
  RETAIL = 'Retail',
  SUSTAINABLE_BUSINESS = 'Sustainable Business'
}

const MAIN = {
  ...BASE_QUERY,
  query: {
    ...BASE_QUERY.query,
    or: [{ terms: { key: 'SectionType', value: ['logistics report'] } }],
    not: [...BASE_QUERY.query.not, ruleNewsPlus]
  }
};

const SECTION_TOP = {
  ...MAIN,
  ...DEFAULT_SECTION_TOP_COUNT
};

const ECONOMY = {
  ...BASE_QUERY,
  query: {
    ...BASE_QUERY.query,
    or: [{ terms: { key: 'DJEThing', value: ['economy/central-banking', 'economy/consumers'] } }]
  }
};

const RETAIL = {
  ...BASE_QUERY,
  query: { ...BASE_QUERY.query, or: [{ terms: { key: 'DJEThing', value: ['business/retail'] } }] }
};

const SUSTAINABLE_BUSINESS = {
  ...BASE_QUERY,
  query: { ...BASE_QUERY.query, or: [{ terms: { key: 'SectionType', value: ['sustainable business'] } }] }
};

const MORE_LIST = { ...MAIN };

export { MAIN, SECTION_TOP, ECONOMY, RETAIL, SUSTAINABLE_BUSINESS, MORE_LIST, SECTION_ENUM };
